@let state = this.state();

<app-page-header
  class="header"
  [backSwipe]="state === 'main' ? backSwipeConfig : undefined"
  [backButtonRouterLink]="['/main', 'home']"
/>

<div class="content">
  <div class="items" coreActivitySection="MoreSelection">
    <button
      class="item"
      [class.active]="state === 'parties'"
      coreUserActivityClickTracking="OpenBirthdayParties"
      (click)="this.state.set('parties')"
    >
      <svg width="58" height="58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="m9.7 38 4-12.2c2-5.5 2.9-8.3 5-8.8 2.2-.5 4.3 1.5 8.4 5.7l8.2 8.2c4.2 4 6.2 6.2 5.7 8.4-.5 2.1-3.3 3-8.8 5l-12.3 4c-6.7 2.2-10 3.3-11.8 1.6C6.4 48 7.5 44.8 9.7 38Z"
              stroke="currentColor" stroke-width="2" stroke-linecap="round"
        />
        <path d="M29.6 44.3s-1.9-5.5-1.9-9.1c0-3.7 1.9-9.2 1.9-9.2M19.5 47s-1.6-6.6-1.8-11c-.5-7 1.8-18.2 1.8-18.2M35 24.2l.4-1.8a5 5 0 0 1 3.3-3.7 5 5 0 0 0 3.3-3.8l.4-1.7M42.5 32l.5.3c1.6 1 3.6.7 5-.5 1.2-1 3-1.4 4.5-.7l.7.3M23.7 6.7c-.8 1.4-.6 3 .5 4.2l.2.2c1 1 1.3 2.4 1 3.6"
              stroke="currentColor" stroke-width="2" stroke-linecap="round"
        />
        <path d="M16.7 9.5a1.3 1.3 0 1 1 1.9 1.9 1.3 1.3 0 0 1-1.9-1.9ZM29.4 17.3a1.3 1.3 0 1 1 1.8 1.8 1.3 1.3 0 0 1-1.8-1.8ZM41.5 24.5a1.3 1.3 0 1 1 1.8 1.9 1.3 1.3 0 0 1-1.8-1.9ZM46 37a1.3 1.3 0 1 1 1.9 1.8A1.3 1.3 0 0 1 46 37Z"
              fill="currentColor"/>
        <path d="M46.8 18.6c-1.6 1.7-.5 6.4-.5 6.4s4.7 1.1 6.3-.5c1.8-1.7.8-4-1.8-4 0-2.6-2.3-3.6-4-1.9Z"
              stroke="currentColor" stroke-width="2" stroke-linejoin="round"
        />
        <path d="M36.7 8.3v.2l-.2.5.3.5.1.2c.5.7.7 1.1.6 1.4-.2.4-.7.4-1.6.5h-.8l-.3.4-.2.2c-.6.8-.9 1.1-1.2 1.1-.4 0-.5-.5-.9-1.3v-.3l-.3-.4-.4-.2-.3-.1c-.8-.4-1.2-.5-1.3-.9 0-.3.3-.6 1-1.2l.3-.2.3-.3.1-.6v-.2c.1-1 .1-1.4.5-1.6.3-.1.7.1 1.4.6l.2.1.5.3.5-.1.2-.1c1-.3 1.4-.4 1.6-.1.3.2.2.7 0 1.6Z"
              stroke="currentColor" stroke-width="2"
        />
      </svg>
      <span class="label">Birthday Parties</span>
    </button>

    <button
      class="item"
      [class.active]="state === 'reservations'"
      coreUserActivityClickTracking="OpenReservations"
      (click)="this.state.set('reservations')"
    >
      <svg width="58" height="58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.8 29c0-9.1 0-13.7 2.9-16.5 2.8-2.8 7.4-2.8 16.5-2.8h9.6c9.1 0 13.7 0 16.5 2.8 2.9 2.8 2.9 7.4 2.9 16.5v4.8c0 9.1 0 13.7-2.9 16.5-2.8 2.9-7.4 2.9-16.5 2.9h-9.6c-9.1 0-13.7 0-16.5-2.9-2.9-2.8-2.9-7.4-2.9-16.5V29Z"
              stroke="currentColor" stroke-width="2"
        />
        <path d="M17 9.7V6M41 9.7V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="39.9" cy="39.9" r="3.6" stroke="currentColor" stroke-width="2"/>
        <path d="M6 21.8h46" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span class="label">Reservations</span>
    </button>

    <button
      class="item"
      [class.active]="state === 'booking'"
      coreUserActivityClickTracking="OpenBooking"
      (click)="this.state.set('booking')"
    >
      <svg width="58" height="58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="29" cy="14.5" r="9.7"
                stroke="currentColor" stroke-width="2"
        />
        <path d="M43.5 21.7c4 0 7.3-2.7 7.3-6s-3.3-6-7.3-6M14.5 21.7c-4 0-7.3-2.7-7.3-6s3.3-6 7.3-6"
              stroke="currentColor" stroke-width="2" stroke-linecap="round"
        />
        <ellipse cx="29" cy="41.1" rx="14.5" ry="9.7"
                 stroke="currentColor" stroke-width="2"
        />
        <path d="M48.3 46c4.3-1 7.3-3.4 7.3-6.1 0-2.8-3-5.1-7.3-6M9.7 46c-4.3-1-7.3-3.4-7.3-6.1 0-2.8 3-5.1 7.3-6"
              stroke="currentColor" stroke-width="2" stroke-linecap="round"
        />
      </svg>
      <span class="label">Group booking</span>
    </button>

    <button
      class="item"
      [class.active]="state === 'membership'"
      coreUserActivityClickTracking="OpenMembership"
      (click)="this.state.set('membership')"
    >

      <svg width="58" height="58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="21.7" cy="21.7" r="4.8"
                stroke="currentColor" stroke-width="2"
        />
        <path d="M31.4 36.2c0 2.7 0 4.9-9.6 4.9-9.7 0-9.7-2.2-9.7-4.9 0-2.6 4.3-4.8 9.7-4.8 5.3 0 9.6 2.2 9.6 4.8Z"
              stroke="currentColor" stroke-width="2"
        />
        <path d="M4.8 29c0-9.1 0-13.7 2.9-16.5 2.8-2.8 7.4-2.8 16.5-2.8h9.6c9.1 0 13.7 0 16.5 2.8 2.9 2.8 2.9 7.4 2.9 16.5s0 13.7-2.9 16.5c-2.8 2.8-7.4 2.8-16.5 2.8h-9.6c-9.1 0-13.7 0-16.5-2.8-2.9-2.8-2.9-7.4-2.9-16.5Z"
              stroke="currentColor" stroke-width="2"
        />
        <path d="M46 29h-9.8M46 21.8H33.7M46 36.3h-7.3"
              stroke="currentColor" stroke-width="2" stroke-linecap="round"
        />
      </svg>
        <span class="label">Membership</span>
    </button>

    <button
      class="item"
      [class.active]="state === 'bowling'"
      coreUserActivityClickTracking="OpenLeagueBowling"
      (click)="this.state.set('bowling')"
    >

      <svg width="58" height="58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M29 38.7c-14 0-16.4-14-16.8-25-.1-3-.2-4.5 1-6 1-1.3 2.5-1.6 5.2-2a63.7 63.7 0 0 1 21.2 0c2.7.4 4.1.7 5.3 2 1.1 1.5 1 3 1 6-.5 11-3 25-16.9 25Z"
              stroke="currentColor" stroke-width="2"
        />
        <path d="m46 12 2.2.8c2.4.8 3.6 1.2 4.3 2.2.7 1 .7 2.2.7 4.7v.2c0 2 0 3.1-.5 4-.5.8-1.4 1.3-3.3 2.3l-7.1 4M12 12l-2.2.8c-2.4.8-3.6 1.2-4.3 2.2-.7 1-.7 2.2-.7 4.7v.2c0 2 0 3.1.5 4 .5.8 1.4 1.3 3.3 2.3l7.1 4"
              stroke="currentColor" stroke-width="2"
        />
        <path d="M29 41v5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M37.5 53.2h-17l.9-4.1c.2-1.2 1.2-2 2.3-2h10.6c1.1 0 2.1.8 2.3 2l.9 4Z"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        />
        <path d="M43.5 53.2h-29"
              stroke="currentColor" stroke-width="2" stroke-linecap="round"/><ellipse cx="29.1" cy="20.8" rx="9.8" ry="9.9" stroke="currentColor" stroke-width="2"
      />
        <circle cx="28.9" cy="15.7" transform="rotate(-90 28.9 15.7)" fill="currentColor" r="1.4"/>
        <circle cx="28.9" cy="20.9" transform="rotate(-90 28.9 21)" fill="currentColor" r="1.4"/>
        <path d="M25.2 16.9a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8Z" fill="currentColor"/>
      </svg>
        <span class="label">League bowling</span>
    </button>

    <button
      class="item"
      [class.active]="state === 'review'"
      coreUserActivityClickTracking="OpenLeaveReview"
      (click)="this.state.set('review')"
    >
      <svg width="58" height="58" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" r="26.7" stroke="currentColor" stroke-width="2"/>
        <path
          d="M28.2 21.9c1.7-3 2.5-4.6 3.8-4.6 1.3 0 2.1 1.5 3.8 4.6l.4.8c.5.8.8 1.3 1.1 1.5.4.3.9.4 1.8.6l.8.2c3.3.8 5 1.1 5.4 2.4.3 1.3-.8 2.6-3 5.2l-.6.6c-.6.8-1 1.2-1 1.6-.2.5-.2 1 0 2v.9c.3 3.5.5 5.2-.5 6-1 .8-2.6 0-5.6-1.4l-.8-.3c-.9-.4-1.3-.6-1.8-.6s-.9.2-1.8.6l-.8.3c-3 1.4-4.6 2.2-5.6 1.4-1-.8-.8-2.5-.5-6v-1c.2-1 .2-1.4 0-1.9 0-.4-.4-.8-1-1.6l-.6-.6c-2.2-2.6-3.3-4-3-5.2.4-1.3 2-1.6 5.4-2.4l.8-.2c1-.2 1.4-.3 1.8-.6.3-.2.6-.7 1-1.5l.5-.8Z"
          stroke="currentColor" stroke-width="2"/>
      </svg>
      <span class="label">Leave a review</span>
    </button>

  </div>
</div>

@switch (state) {
  @case ('parties') {
    <app-more-parties
      @InOutAnimation
      class="full-page"
      (back)="this.state.set('main')"
    />
  }
  @case ('reservations') {
    <app-more-reservations
      @InOutAnimation
      class="full-page"
      (back)="this.state.set('main')"
    />
  }
  @case ('booking') {
    <app-more-group-events
      @InOutAnimation
      class="full-page"
      (back)="this.state.set('main')"
    />
  }
  @case ('membership') {
    <app-more-membership
      @InOutAnimation
      class="full-page"
      (back)="this.state.set('main')"
    />
  }
  @case ('bowling') {
    <app-more-league-bowling
      @InOutAnimation
      class="full-page"
      (back)="this.state.set('main')"
    />
  }
  @case ('review') {
    <app-more-review
      @InOutAnimation
      class="full-page"
      (back)="this.state.set('main')"
    />
  }
}
